export function getUtmParams(search = window.location.search) {
  const params = new URLSearchParams(search)
  return {
    utmSource: params.get('utm_source') ?? '',
    utmMedium: params.get('utm_medium') ?? '',
    utmCampaign: params.get('utm_campaign') ?? '',
  }
}
